import { DraftScope } from "../types";

/** Prefix shared by every DynamicForm draft key, across all host namespaces. */
export const DRAFT_KEY_PREFIX = "wsapp_";

/**
 * `namespace` is the host surface's draft-key segment (see
 * DynamicFormEngineConfig.draftKeyNamespace) so different consumers of the
 * engine never collide in localStorage.
 */
export const deriveDraftKey = (scope: DraftScope, namespace: string): string =>
  `${DRAFT_KEY_PREFIX}${namespace}_${scope.payeeId}_${scope.contextId}_${scope.formId}_${scope.version}`;

/**
 * Removes EVERY DynamicForm draft from localStorage (all namespaces/scopes).
 * Called on sign-out so an abandoned form on a shared browser leaves no
 * form values behind.
 */
export const clearAllDynamicFormDrafts = (): void => {
  try {
    Object.keys(window.localStorage)
      .filter(key => key.startsWith(DRAFT_KEY_PREFIX))
      .forEach(key => window.localStorage.removeItem(key));
  } catch {
    // localStorage may be unavailable (privacy mode) — nothing to clear then.
  }
};
